export enum MassiveSendingType
{
    SingleSending = 0,
    Annual,
    Birthdays
}
  